import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Copy, Check, Share2 } from 'lucide-react';
import { toast } from '../../hooks/use-toast';

// Código personal del closer + link/QR de venta. El cliente escanea, cae en
// /signup?code=X con el descuento pre-aplicado y la venta queda atribuida.
const MyCodeTab = ({ profile }) => {
  const [copied, setCopied] = useState(null);

  const copy = async (text, which) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(which);
      setTimeout(() => setCopied(null), 1800);
    } catch (err) {
      toast({
        title: 'No se pudo copiar',
        description: 'Copia el texto manualmente.',
        variant: 'destructive',
      });
    }
  };

  const share = async () => {
    if (!navigator.share) {
      copy(profile.sale_link, 'link');
      return;
    }
    try {
      await navigator.share({
        title: 'Activa tu acceso VONDI',
        text: `Usa mi código ${profile.code} y obtén ${profile.discount_percent}% de descuento.`,
        url: profile.sale_link,
      });
    } catch (err) {
      // El usuario canceló el diálogo de compartir; no es un error.
    }
  };

  const card = {
    background: '#fff',
    borderRadius: 20,
    border: '1px solid rgba(0,0,0,0.06)',
    padding: 18,
  };

  if (!profile) {
    return (
      <div style={{ padding: '8px 20px 20px' }}>
        <div style={{ ...card, textAlign: 'center', color: '#9CA3AF', fontSize: 14 }}>
          Cargando tu código...
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '8px 20px 20px' }}>
      <div style={{ marginBottom: 14 }}>
        <h2 style={{ fontSize: 19, fontWeight: 700, color: '#0A0A0A', letterSpacing: '-0.02em' }}>
          Tu código de venta
        </h2>
        <p style={{ fontSize: 13.5, color: '#6B7280', marginTop: 3 }}>
          Toda venta hecha con tu código cuenta como activación tuya.
        </p>
      </div>

      {/* Código grande */}
      <div style={{
        background: '#0A0A0A', color: '#fff', borderRadius: 24, padding: '26px 22px',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 12.5, opacity: 0.6, fontWeight: 500, letterSpacing: '0.05em' }}>
          CÓDIGO
        </div>
        <div style={{
          fontSize: 40, fontWeight: 800, letterSpacing: '0.04em', marginTop: 6, lineHeight: 1.1,
        }}>
          {profile.code}
        </div>
        <div style={{ fontSize: 14, opacity: 0.7, marginTop: 6 }}>
          {profile.discount_percent}% de descuento en el primer pago
        </div>

        <button
          onClick={() => copy(profile.code, 'code')}
          style={{
            marginTop: 18, width: '100%', height: 48, borderRadius: 9999,
            background: '#fff', color: '#0A0A0A', border: 'none', cursor: 'pointer',
            fontSize: 15, fontWeight: 700,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}>
          {copied === 'code' ? <Check size={17} /> : <Copy size={17} />}
          {copied === 'code' ? 'Copiado' : 'Copiar código'}
        </button>
      </div>

      {/* QR de venta */}
      <div style={{ ...card, marginTop: 12, textAlign: 'center' }}>
        <div style={{ fontSize: 14.5, fontWeight: 700, color: '#0A0A0A' }}>
          Que escanee este QR
        </div>
        <div style={{ fontSize: 13, color: '#6B7280', marginTop: 3, marginBottom: 16 }}>
          Abre el registro con tu código ya aplicado.
        </div>

        <div style={{
          display: 'inline-flex', padding: 16, background: '#fff',
          borderRadius: 18, border: '1px solid rgba(0,0,0,0.06)',
        }}>
          <QRCodeSVG value={profile.sale_link} size={200} level="H" includeMargin={false} />
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button
            onClick={() => copy(profile.sale_link, 'link')}
            style={{
              flex: 1, height: 46, borderRadius: 14, cursor: 'pointer',
              border: '1px solid rgba(0,0,0,0.1)', background: '#fff', color: '#0A0A0A',
              fontSize: 14, fontWeight: 600,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
            }}>
            {copied === 'link' ? <Check size={15} /> : <Copy size={15} />}
            {copied === 'link' ? 'Copiado' : 'Copiar link'}
          </button>
          <button
            onClick={share}
            style={{
              flex: 1, height: 46, borderRadius: 14, cursor: 'pointer',
              border: 'none', background: '#0A0A0A', color: '#fff',
              fontSize: 14, fontWeight: 600,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
            }}>
            <Share2 size={15} /> Compartir
          </button>
        </div>
      </div>

      {!profile.is_active && (
        <div style={{
          ...card, marginTop: 12, background: '#FEF2F2', borderColor: '#FECACA',
          color: '#B91C1C', fontSize: 13.5, fontWeight: 600, textAlign: 'center',
        }}>
          Tu código está desactivado. Contacta a administración.
        </div>
      )}
    </div>
  );
};

export default MyCodeTab;
